
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Normal_lochia_trait",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Normal_lochia_trait.vue